<template>
    <component
        :is="is"
        :data="data"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { FooterMenuItemFragment } from '@/graphql/api'
import { assertNever } from '@/helpers'

import FooterItemDivider from '@/components/layout/footer/FooterItemDivider.vue'
import FooterItemLinkList from '@/components/layout/footer/FooterItemLinkList.vue'
import FooterItemText from '@/components/layout/footer/FooterItemText.vue'
import FooterItemWorkingHours from '@/components/layout/footer/FooterItemWorkingHours.vue'
import FooterItemTitle from '@/components/layout/footer/FooterItemTitle.vue'
import DebugComponent from '@/components/cms/component/DebugComponent.vue'

const props = defineProps<{
    data: FooterMenuItemFragment
}>()

const is = computed((): any => {
    const type = props.data.__typename

    switch (type) {
        case 'FooterColumnItemLinkList':
            return FooterItemLinkList
        case 'FooterColumnItemSeparator':
            return FooterItemDivider
        case 'FooterColumnItemText':
            return FooterItemText
        case 'FooterColumnItemTitle':
            return FooterItemTitle
        case 'FooterColumnItemWorkingHours':
            return FooterItemWorkingHours
        default:
            return assertNever(type, DebugComponent)
    }
})
</script>
